import { uuid } from '@yola/ws-sdk';
import optionTypes from '../constants/option-types';

const buildDividerOption = (id = null) => ({
  id: `divider-${id || uuid()}`,
  type: optionTypes.DIVIDER,
});

export default buildDividerOption;
